import moment from 'moment-timezone';

import { types } from '../constants/filter';
import { FULL_DATE_FORMAT } from '../constants/date';
import { splitPostfix } from '../constants/event';

export const timeUnits = {
  HOUR: 'hour',
  DAY: 'day',
  WEEK: 'isoWeek',
  MONTH: 'month',
  QUARTER: 'quarter',
};

export const getRange = (fromRange, toRangeParam, timezone, timeUnit) => {
  const from = moment.tz(fromRange, FULL_DATE_FORMAT, timezone).startOf(timeUnit);
  const to = moment.tz(toRangeParam, FULL_DATE_FORMAT, timezone).startOf(timeUnit);

  return {
    from: from.valueOf(),
    to: [timeUnits.HOUR, timeUnits.DAY].includes(timeUnit)
      ? to.subtract(1, timeUnit).valueOf()
      : to.valueOf(),
  };
};

export const toRange = ({ query, timeUnit, timezone }) =>
  getRange(query.globalFilter.from, query.globalFilter.to, timezone, timeUnit);

export const getAggregations = (aggregations = []) =>
  aggregations.map(({ field, type }) =>
    field ? `${type.toLowerCase()}.${field}` : type.toLowerCase()
  );

const getColumnsFromQuery = (query, split) => {
  const [groupBy] = query.groupBy;

  const groups = [groupBy, split].filter((group) => !!group);
  return [].concat(groups).concat(getAggregations(query.aggregations));
};

export const toEventResult = (result, query, uniqueChar, getType, isEventsWithOthers) => {
  const [groupBy, splitBy] = query.groupBy;
  const split = splitBy === groupBy && isEventsWithOthers ? `${splitBy}${splitPostfix}` : splitBy;

  const rows =
    getType(groupBy).type === types.NUMBER
      ? result.rows.map((row) =>
          splitBy
            ? { ...row, [groupBy]: String(row[groupBy]), [split]: row[splitBy] }
            : { ...row, [groupBy]: String(row[groupBy]) }
        )
      : result.rows.map((row) => (splitBy ? { ...row, [split]: row[splitBy] } : row));

  return {
    info: {
      typeGroupBy: getType(groupBy).type,
      groupBy,
      splitBy,
      aggregation: getAggregations(query.aggregations),
      type: 'eventsResult',
      query,
      uniqueChar,
      eventName: query.eventName,
      timeUnit: timeUnits[groupBy],
      timezone: query.timezone,
    },
    result: {
      columns: getColumnsFromQuery(query, split),
      rows,
    },
  };
};

export const createEvents = (response) => ({
  ...response,
  events: Object.keys(response.meta.events),
});
